var map = {
	"./about-cropped.png": 41810,
	"./about.jpg": 18296,
	"./article/Designing_Genie-hero-20.jpg": 50875,
	"./article/agentic-ai-brand-trust.jpg": 50461,
	"./article/baseline.png": 77515,
	"./article/bike.gif": 73354,
	"./article/cover1.png": 75108,
	"./article/cover2.png": 5023,
	"./article/cover3.png": 26934,
	"./article/cover4.png": 1193,
	"./article/design-help.png": 8050,
	"./article/genie.png": 48776,
	"./article/jacques.jpg": 39672,
	"./article/token-article.jpg": 34918,
	"./article/with-tokens.png": 15091,
	"./article/without-tokens.png": 55745,
	"./avatar/avatar-2026-headshot-flipped-nobg.svg": 95198,
	"./avatar/avatar-2026-headshot-flipped.svg": 17969,
	"./avatar/avatar-2026-headshot.svg": 6726,
	"./avatar/avatar-2026-torso-line.svg": 88176,
	"./avatar/avatar-2026-torso-nobg.svg": 22214,
	"./avatar/avatar-2026-torso.svg": 78713,
	"./avatar/avatar-a.svg": 89674,
	"./avatar/avatar-alt.svg": 75474,
	"./avatar/avatar-body-crop-flipped-line.svg": 51322,
	"./avatar/avatar-body-crop-flipped.svg": 39923,
	"./avatar/avatar-body-crop-line.svg": 59547,
	"./avatar/avatar-body-crop.svg": 11332,
	"./avatar/avatar-body-front-crop-line.svg": 14753,
	"./avatar/avatar-body-front-crop.svg": 71850,
	"./avatar/avatar-body-front-full-line.svg": 86894,
	"./avatar/avatar-body-front-full.svg": 79023,
	"./avatar/avatar-body-front-torso-line.svg": 58880,
	"./avatar/avatar-body-front-torso.svg": 45833,
	"./avatar/avatar-body-full-flipped-line.svg": 9093,
	"./avatar/avatar-body-full-flipped.svg": 41782,
	"./avatar/avatar-body-full-line.svg": 68520,
	"./avatar/avatar-body-full.svg": 1441,
	"./avatar/avatar-body-torso-flipped-line.svg": 36739,
	"./avatar/avatar-body-torso-flipped.svg": 4668,
	"./avatar/avatar-body-torso-line.svg": 14314,
	"./avatar/avatar-body-torso.svg": 23139,
	"./avatar/avatar-bust-line.svg": 31942,
	"./avatar/avatar-bust.svg": 30583,
	"./avatar/avatar-front-line.svg": 26085,
	"./avatar/avatar-front.svg": 82518,
	"./avatar/avatar-h.svg": 57059,
	"./avatar/avatar-head-flipped-line.svg": 37595,
	"./avatar/avatar-head-flipped.svg": 49540,
	"./avatar/avatar-head-front-line.svg": 53832,
	"./avatar/avatar-head-front.svg": 62529,
	"./avatar/avatar-head-line.svg": 50290,
	"./avatar/avatar-head.svg": 80571,
	"./avatar/avatar-shirt.svg": 22727,
	"./avatar/avatar-torso-flipped.svg": 75957,
	"./avatar/avatar-torso.svg": 71458,
	"./avatar/avatar.svg": 12756,
	"./bg.jpg": 45150,
	"./blank-wide.svg": 78845,
	"./blank.svg": 26631,
	"./blob.png": 38802,
	"./blob.svg": 82122,
	"./card/portrait-4x5.jpg": 21201,
	"./card/qr-card.svg": 83924,
	"./casestudy/ax-workshop/agent-card.png": 5841,
	"./casestudy/ax-workshop/process-audit.png": 48338,
	"./casestudy/ax-workshop/workflow.png": 79800,
	"./casestudy/counter-fill/audi-fox.jpg": 64011,
	"./casestudy/counter-fill/capcom.png": 63755,
	"./casestudy/counter-fill/counter-fill-2.png": 87143,
	"./casestudy/counter-fill/counter-fill.png": 17142,
	"./casestudy/counter-fill/packy-marlon.png": 86354,
	"./casestudy/counter-fill/popular-magazine.jpg": 78138,
	"./casestudy/counter-fill/subtone-poster.png": 9520,
	"./casestudy/design-as-specification/retailer-after.jpg": 89918,
	"./casestudy/design-as-specification/retailer-before.jpg": 23751,
	"./casestudy/design-kit/retailer-after.jpg": 88348,
	"./casestudy/design-kit/retailer-before.jpg": 94049,
	"./casestudy/eqx/eqx-1.png": 74954,
	"./casestudy/eqx/eqx-2.png": 23937,
	"./casestudy/eqx/eqx-connection-diagrams.jpg": 61024,
	"./casestudy/eqx/eqx-explore.png": 15654,
	"./casestudy/eqx/eqx-icon-library.png": 34910,
	"./casestudy/eqx/eqx-icons.png": 87793,
	"./casestudy/eqx/eqx-pattern-library.jpg": 92011,
	"./casestudy/eqx/eqx-portal.jpg": 19129,
	"./casestudy/eqx/eqx-screens.jpg": 15096,
	"./casestudy/eqx/eqx-story-map.jpg": 96129,
	"./casestudy/eqx/shots/built-connect.jpg": 89429,
	"./casestudy/eqx/shots/built-dashboard.jpg": 96291,
	"./casestudy/eqx/shots/built-modal-hero.jpg": 82251,
	"./casestudy/eqx/shots/built-topology.jpg": 59004,
	"./casestudy/eqx/shots/d-cc-landing.jpg": 21483,
	"./casestudy/eqx/shots/d-dashboard.jpg": 26391,
	"./casestudy/eqx/shots/d-inv-cards.jpg": 67244,
	"./casestudy/eqx/shots/d-inv-list.jpg": 41337,
	"./casestudy/eqx/shots/d-inv-modal.jpg": 19318,
	"./casestudy/eqx/shots/d-locations.jpg": 63375,
	"./casestudy/eqx/shots/d-nfv-details.jpg": 39764,
	"./casestudy/eqx/shots/d-nfv-interfaces.jpg": 36880,
	"./casestudy/eqx/shots/d-port-detail.jpg": 35246,
	"./casestudy/eqx/shots/d-ports.jpg": 27851,
	"./casestudy/eqx/shots/d-select-sp.jpg": 44015,
	"./casestudy/eqx/shots/d-speed.jpg": 15334,
	"./casestudy/eqx/shots/design-topology.jpg": 55044,
	"./casestudy/eqx/shots/lib-colours.jpg": 75797,
	"./casestudy/eqx/shots/lib-forms.jpg": 95223,
	"./casestudy/eqx/shots/lib-inventory-cards.jpg": 99456,
	"./casestudy/eqx/shots/lib-nav.jpg": 55085,
	"./casestudy/eqx/shots/lib-speed.jpg": 6067,
	"./casestudy/eqx/shots/lib-type.jpg": 70112,
	"./casestudy/eqx/thumb.png": 61262,
	"./casestudy/f100/thumb-planner.png": 32268,
	"./casestudy/genie/audit-annotated.png": 84674,
	"./casestudy/genie/genie.png": 54056,
	"./casestudy/glo/details.png": 99342,
	"./casestudy/glo/insights.png": 98637,
	"./casestudy/glo/planner.png": 72356,
	"./casestudy/harness/genie-batch-audit.png": 27605,
	"./casestudy/harness/genie-proposed-page.png": 48325,
	"./casestudy/harness/hero-templates-at-scale.jpg": 66053,
	"./casestudy/harness/kit-storybook-templates.jpg": 45137,
	"./casestudy/harness/one-template-four-brands.jpg": 69877,
	"./casestudy/harness/retailer-after-plate.jpg": 87944,
	"./casestudy/harness/retailer-before-plate.jpg": 38603,
	"./casestudy/harness/shots/genie-full.jpg": 17530,
	"./casestudy/harness/shots/genie-zoom.jpg": 83008,
	"./casestudy/harness/shots/hero/a-blog.jpg": 85239,
	"./casestudy/harness/shots/hero/a-checkout.jpg": 97695,
	"./casestudy/harness/shots/hero/a-home-m.jpg": 52036,
	"./casestudy/harness/shots/hero/a-home.jpg": 56034,
	"./casestudy/harness/shots/hero/a-pdp-m.jpg": 83309,
	"./casestudy/harness/shots/hero/a-pdp.jpg": 33671,
	"./casestudy/harness/shots/hero/a-plp.jpg": 12463,
	"./casestudy/harness/shots/hero/a-store.jpg": 36180,
	"./casestudy/harness/shots/hero/k-acct-m.jpg": 65050,
	"./casestudy/harness/shots/hero/k-acct.jpg": 69016,
	"./casestudy/harness/shots/hero/k-blog-m.jpg": 74615,
	"./casestudy/harness/shots/hero/k-blog.jpg": 75209,
	"./casestudy/harness/shots/hero/k-bulk.jpg": 98277,
	"./casestudy/harness/shots/hero/k-cart-m.jpg": 45541,
	"./casestudy/harness/shots/hero/k-cart.jpg": 81343,
	"./casestudy/harness/shots/hero/k-checkout-m.jpg": 59139,
	"./casestudy/harness/shots/hero/k-conf.jpg": 19343,
	"./casestudy/harness/shots/hero/k-home-dark-m.jpg": 23601,
	"./casestudy/harness/shots/hero/k-home-dark.jpg": 45387,
	"./casestudy/harness/shots/hero/k-home-m.jpg": 48118,
	"./casestudy/harness/shots/hero/k-home.jpg": 62484,
	"./casestudy/harness/shots/hero/k-pay.jpg": 8851,
	"./casestudy/harness/shots/hero/k-pdp-dark.jpg": 22052,
	"./casestudy/harness/shots/hero/k-pdp-m.jpg": 46423,
	"./casestudy/harness/shots/hero/k-pdp.jpg": 91849,
	"./casestudy/harness/shots/hero/k-plp-dark.jpg": 74844,
	"./casestudy/harness/shots/hero/k-plp-m.jpg": 89983,
	"./casestudy/harness/shots/hero/k-plp.jpg": 98609,
	"./casestudy/harness/shots/hero/k-store.jpg": 29050,
	"./casestudy/harness/shots/hero/w-cart.jpg": 5587,
	"./casestudy/harness/shots/hero/w-home.jpg": 45336,
	"./casestudy/harness/shots/hero/w-pdp.jpg": 98949,
	"./casestudy/harness/shots/hero/w-plp.jpg": 78573,
	"./casestudy/harness/shots/ksb1.jpg": 64509,
	"./casestudy/harness/shots/ksb2.jpg": 45554,
	"./casestudy/harness/shots/pdp-a-pdp.jpg": 63903,
	"./casestudy/harness/shots/pdp-k-pdp-dark.jpg": 14332,
	"./casestudy/harness/shots/pdp-k-pdp.jpg": 22577,
	"./casestudy/harness/shots/pdp-w-pdp.jpg": 83805,
	"./casestudy/harness/shots/sb1.jpg": 45434,
	"./casestudy/harness/shots/sb4.jpg": 70875,
	"./casestudy/harness/thumb-terminal.png": 87227,
	"./casestudy/harness/workspace-storybook.jpg": 19864,
	"./casestudy/ide/temp-ide.png": 68795,
	"./casestudy/kg/kg-1.jpg": 66852,
	"./casestudy/kg/kg-2.jpg": 61011,
	"./casestudy/kg/kg-3.jpg": 74550,
	"./casestudy/kg/kg-4.png": 5133,
	"./casestudy/kg/kg-5.png": 78980,
	"./casestudy/kg/kg-web-hero.jpg": 41442,
	"./casestudy/onlogic/Checkout/d Checkout-Cart Page.png": 7060,
	"./casestudy/onlogic/Checkout/d Checkout-Product Added.png": 82672,
	"./casestudy/onlogic/Checkout/m Checkout-Cart Page.png": 63091,
	"./casestudy/onlogic/Product - Detail/Configuration/d PDP with Product Configuration-Coming Soon.png": 25994,
	"./casestudy/onlogic/Product - Detail/Configuration/d PDP with Product Configuration-Details Expanded-Scrolling.png": 71729,
	"./casestudy/onlogic/Product - Detail/Configuration/d PDP with Product Configuration-Discontinued.png": 20995,
	"./casestudy/onlogic/Product - Detail/Configuration/d PDP with Product Configuration-Modals.png": 60516,
	"./casestudy/onlogic/Product - Detail/Configuration/d PDP with Product Configuration-Special Order.png": 13057,
	"./casestudy/onlogic/Product - Detail/Configuration/d PDP with Product Configuration-Sticky-CTA.png": 45526,
	"./casestudy/onlogic/Product - Detail/Configuration/m PDP with Product Configuration-Sticky-CTA-scrolled - alt.png": 37742,
	"./casestudy/onlogic/Product - Detail/Configuration/m PDP with Product Configuration-Sticky-CTA-scrolled.png": 82162,
	"./casestudy/onlogic/Product - Detail/Configuration/m PDP with Product Configuration-Sticky-CTA.png": 31767,
	"./casestudy/onlogic/Product - Detail/No Config/d PDP with Product No Config.png": 15017,
	"./casestudy/onlogic/Product Comparison/d Product Comparison Page-Default.png": 70535,
	"./casestudy/onlogic/Product Comparison/dCompare-PLP-Selected-Default.png": 20034,
	"./casestudy/onlogic/Product Comparison/m Product Comparison Page-Default.png": 36862,
	"./casestudy/onlogic/Product Comparison/mComparison-PLP-Selected-Revealed.png": 59240,
	"./casestudy/onlogic/onlogic-1.png": 7946,
	"./casestudy/onlogic/onlogic-2.png": 38529,
	"./casestudy/onlogic/onlogic-3.png": 17400,
	"./casestudy/onlogic/onlogic-cart-detail.png": 9131,
	"./casestudy/onlogic/onlogic-cart-plate.jpg": 21210,
	"./casestudy/onlogic/onlogic-pdp-config-plate.jpg": 33131,
	"./casestudy/onlogic/onlogic-pdp-config.png": 81264,
	"./casestudy/onlogic/product-comparison-plate.jpg": 3665,
	"./casestudy/onlogic/product-comparison-thumb.jpg": 20745,
	"./casestudy/onlogic/product-comparison.png": 45398,
	"./casestudy/pd-dash/pd-dash.png": 52872,
	"./casestudy/softchoice/ad-banners.png": 99104,
	"./casestudy/softchoice/asset-cards.png": 5415,
	"./casestudy/softchoice/asset-matrix.png": 30879,
	"./casestudy/softchoice/event-lp-email-banners.png": 64941,
	"./casestudy/softchoice/promo-cards.png": 32318,
	"./casestudy/softchoice/sc-before-after.jpg": 65710,
	"./casestudy/softchoice/sc-blog-1.png": 12376,
	"./casestudy/softchoice/sc-blog-hero.png": 94101,
	"./casestudy/softchoice/sc-desktop-1.png": 12254,
	"./casestudy/softchoice/sc-guide-1.png": 88358,
	"./casestudy/softchoice/sc-guide-2.png": 29597,
	"./casestudy/softchoice/sc-guide-detail.png": 31452,
	"./casestudy/softchoice/sc-home-desktop-mobile.jpg": 46429,
	"./casestudy/softchoice/sc-modules-detail.png": 64325,
	"./casestudy/softchoice/sc-modules.jpg": 75959,
	"./casestudy/softchoice/sc-motion-sequence.png": 45840,
	"./casestudy/softchoice/sc-motion.gif": 68095,
	"./casestudy/softchoice/sc-templates.jpg": 48249,
	"./casestudy/softchoice/sc-ui-guide-pages.jpg": 10524,
	"./casestudy/softchoice/shots/ba-hero-after.jpg": 9690,
	"./casestudy/softchoice/shots/ba-hero-before.jpg": 77731,
	"./casestudy/softchoice/shots/ba-quadrant-after.jpg": 56098,
	"./casestudy/softchoice/shots/ba-quadrant-before.jpg": 37931,
	"./casestudy/softchoice/shots/ba-stats-after.jpg": 33547,
	"./casestudy/softchoice/shots/ba-stats-before.jpg": 99616,
	"./casestudy/softchoice/shots/ba-twocol-after.jpg": 80178,
	"./casestudy/softchoice/shots/ba-twocol-before.jpg": 82843,
	"./casestudy/softchoice/shots/guide-cover-hi.jpg": 73777,
	"./casestudy/softchoice/shots/guide-page-02.jpg": 29460,
	"./casestudy/softchoice/shots/guide-page-03.jpg": 24337,
	"./casestudy/softchoice/shots/guide-page-04.jpg": 11426,
	"./casestudy/softchoice/shots/guide-page-05.jpg": 31423,
	"./casestudy/softchoice/shots/guide-page-06.jpg": 16464,
	"./casestudy/softchoice/shots/guide-page-07.jpg": 59917,
	"./casestudy/softchoice/shots/guide-page-08.jpg": 44910,
	"./casestudy/softchoice/shots/guide-page-09.jpg": 71371,
	"./casestudy/softchoice/shots/guide-page-10.jpg": 22813,
	"./casestudy/softchoice/shots/guide-page-11.jpg": 97248,
	"./casestudy/softchoice/shots/guide-page-12.jpg": 80239,
	"./casestudy/softchoice/shots/guide-page-13.jpg": 3858,
	"./casestudy/softchoice/shots/guide-page-14.jpg": 15553,
	"./casestudy/softchoice/shots/guide-page-15.jpg": 37508,
	"./casestudy/softchoice/shots/guide-page-16.jpg": 37555,
	"./casestudy/softchoice/shots/guide-page-17.jpg": 82294,
	"./casestudy/softchoice/shots/guide-page-18.jpg": 42405,
	"./casestudy/softchoice/shots/guide-page-19.jpg": 14792,
	"./casestudy/softchoice/shots/guide-page-20.jpg": 140,
	"./casestudy/softchoice/shots/guide-page-21.jpg": 45513,
	"./casestudy/softchoice/shots/guide-page-22.jpg": 71806,
	"./casestudy/softchoice/shots/guide-page-23.jpg": 26587,
	"./casestudy/softchoice/shots/guide-page-24.jpg": 3912,
	"./casestudy/softchoice/shots/guide-page-25.jpg": 66277,
	"./casestudy/softchoice/shots/guide-page-26.jpg": 43674,
	"./casestudy/softchoice/shots/guide-page-27.jpg": 54487,
	"./casestudy/softchoice/shots/home-desktop-top.jpg": 25635,
	"./casestudy/softchoice/shots/home-mobile-1.jpg": 64749,
	"./casestudy/softchoice/shots/home-mobile-2.jpg": 32610,
	"./casestudy/softchoice/shots/mod-agenda.jpg": 37206,
	"./casestudy/softchoice/shots/mod-cards.jpg": 87733,
	"./casestudy/softchoice/shots/mod-hero-light-dark.jpg": 44672,
	"./casestudy/softchoice/shots/mod-hero.jpg": 5802,
	"./casestudy/softchoice/shots/mod-image-quadrant.jpg": 84138,
	"./casestudy/softchoice/shots/mod-login.jpg": 32507,
	"./casestudy/softchoice/shots/mod-logos.jpg": 13056,
	"./casestudy/softchoice/shots/mod-megamenu.jpg": 5293,
	"./casestudy/softchoice/shots/mod-pagenav.jpg": 41480,
	"./casestudy/softchoice/shots/mod-quadrant-dark.jpg": 42326,
	"./casestudy/softchoice/shots/mod-stats.jpg": 26129,
	"./casestudy/softchoice/shots/mod-text-columns.jpg": 42761,
	"./casestudy/softchoice/shots/mod-two-column.jpg": 68219,
	"./casestudy/softchoice/shots/motion-1.jpg": 47735,
	"./casestudy/softchoice/shots/motion-2.jpg": 13512,
	"./casestudy/softchoice/shots/motion-3.jpg": 75877,
	"./casestudy/softchoice/shots/motion-4.jpg": 81406,
	"./casestudy/softchoice/shots/motion-5.jpg": 36187,
	"./casestudy/softchoice/shots/motion-6.jpg": 93388,
	"./casestudy/softchoice/shots/tpl-blog-detail.jpg": 54258,
	"./casestudy/softchoice/shots/tpl-blog-listing.jpg": 71905,
	"./casestudy/softchoice/shots/tpl-events-detail.jpg": 89111,
	"./casestudy/softchoice/shots/tpl-events-listing.jpg": 36058,
	"./casestudy/softchoice/shots/tpl-newsroom-detail.jpg": 60354,
	"./casestudy/softchoice/shots/tpl-newsroom-listing.jpg": 49041,
	"./casestudy/softchoice/shots/tpl-partners-detail.jpg": 5609,
	"./casestudy/softchoice/shots/tpl-partners-listing.jpg": 40468,
	"./casestudy/softchoice/shots/tpl-resources-detail.jpg": 51201,
	"./casestudy/softchoice/shots/tpl-resources-listing.jpg": 42332,
	"./casestudy/storybook/sb-component-button.png": 32174,
	"./casestudy/storybook/sb-component-pagination.png": 54442,
	"./casestudy/storybook/sb-component-uicontainer.png": 41955,
	"./casestudy/storybook/sb-foundations-colors.png": 97903,
	"./casestudy/storybook/sb-foundations-container.png": 67510,
	"./casestudy/storybook/sb-guide-contributing.png": 76565,
	"./casestudy/storybook/sb-guide-qa.png": 14571,
	"./casestudy/token-pipeline/brand-theme-grid.png": 97700,
	"./casestudy/token-pipeline/design-guard-report.jpg": 34631,
	"./casestudy/token-pipeline/enforcement-layers.jpg": 60777,
	"./casestudy/token-pipeline/hero-token-layers.jpg": 13969,
	"./casestudy/token-pipeline/one-token-three-brands.jpg": 29922,
	"./casestudy/token-pipeline/tap-click-density.jpg": 39477,
	"./casestudy/token-pipeline/thumb-terminal.png": 76381,
	"./casestudy/token-starter/all.png": 79896,
	"./casestudy/token-starter/colors.png": 43101,
	"./casestudy/token-starter/elements.png": 22162,
	"./casestudy/token-starter/spacing.png": 2054,
	"./casestudy/token-starter/typography.png": 88106,
	"./casestudy/ui-lib/datagrid.png": 26690,
	"./casestudy/ui-lib/topology-diagram.png": 29557,
	"./casestudy/ui-lib/topology-map.png": 40292,
	"./dqa.png": 31989,
	"./emoji/emoji-eyebrow.png": 41020,
	"./emoji/emoji-smile.png": 91261,
	"./emoji/emoji-think.png": 99693,
	"./emoji/emoji-wink.png": 10928,
	"./empty.png": 65512,
	"./favicons/fav-dynamic.svg": 4402,
	"./favicons/fav-face.svg": 85684,
	"./favicons/fav-light.svg": 17877,
	"./favicons/fav.svg": 52286,
	"./favicons/favicon.svg": 23997,
	"./favicons/j-uni.svg": 69858,
	"./genie.png": 23079,
	"./gennifer.png": 47747,
	"./icon/backward-arrow.svg": 76372,
	"./icon/chevron.svg": 25844,
	"./icon/eclipse-svgrepo-com.svg": 36859,
	"./icon/github-mark.svg": 1092,
	"./icon/j-logo.svg": 54553,
	"./icon/linkedin.svg": 61985,
	"./icon/print.svg": 47324,
	"./icon/r-icon.svg": 3207,
	"./icon/share.svg": 98452,
	"./jacques.jpg": 81603,
	"./luna.jpg": 17837,
	"./luna1.jpg": 8196,
	"./luna2.jpg": 43475,
	"./mach-meetup-patio.jpg": 91665,
	"./me.jpg": 22449,
	"./merch/drop-01/cap-back.png": 18911,
	"./merch/drop-01/cap.png": 20159,
	"./merch/drop-01/stickers.png": 46227,
	"./merch/drop-01/tee-banana-back.png": 1751,
	"./merch/drop-01/tee-banana.png": 8167,
	"./merch/drop-01/tee-black-front.png": 81097,
	"./merch/drop-01/tee-black.png": 34763,
	"./merch/drop-01/tote-back.png": 47917,
	"./merch/drop-01/tote.png": 37461,
	"./placeholder.png": 16628,
	"./placeholders/placeholder-01.svg": 7289,
	"./placeholders/placeholder-02.svg": 32266,
	"./placeholders/placeholder-03.svg": 92635,
	"./placeholders/placeholder-04.svg": 66516,
	"./placeholders/placeholder-05.svg": 39125,
	"./placeholders/placeholder-06.svg": 67254,
	"./placeholders/placeholder-07.svg": 31079,
	"./placeholders/placeholder-08.svg": 42608,
	"./placeholders/placeholder-09.svg": 78145,
	"./placeholders/placeholder-10.svg": 45547,
	"./placeholders/placeholder-11.svg": 30938,
	"./placeholders/placeholder-12.svg": 99049,
	"./placeholders/placeholder-13.svg": 94808,
	"./placeholders/placeholder-14.svg": 83991,
	"./placeholders/placeholder-15.svg": 69606,
	"./placeholders/placeholder-16.svg": 92037,
	"./placeholders/placeholder-17.svg": 40868,
	"./placeholders/placeholder-18.svg": 52563,
	"./placeholders/placeholder-19.svg": 47394,
	"./placeholders/placeholder-20.svg": 25526,
	"./placeholders/placeholder-21.svg": 81415,
	"./placeholders/placeholder-22.svg": 93556,
	"./placeholders/placeholder-23.svg": 54837,
	"./placeholders/placeholder-24.svg": 83210,
	"./placeholders/placeholder-25.svg": 25179,
	"./placeholders/placeholder-26.svg": 43816,
	"./placeholders/placeholder-27.svg": 9209,
	"./placeholders/placeholder-28.svg": 39390,
	"./placeholders/placeholder-29.svg": 1967,
	"./placeholders/placeholder-30.svg": 93825,
	"./portrait.jpg": 64126,
	"./profile.jpg": 61120,
	"./profile2.jpg": 24520,
	"./shapes.png": 25533,
	"./shapes.svg": 64041,
	"./splash.svg": 74590,
	"./splash4.svg": 20062,
	"./templates/archive/hand2.png": 93735,
	"./templates/archive/hands.png": 18622,
	"./templates/archive/template-desktop-mobile.svg": 10770,
	"./templates/archive/template-lg.svg": 40146,
	"./templates/archive/template-mobile-4.svg": 62780,
	"./templates/archive/template-mobile-v2.svg": 43184,
	"./templates/archive/template-sm.svg": 34845,
	"./templates/template-desktop-blank.svg": 30751,
	"./templates/template-desktop-device.svg": 21341,
	"./templates/template-mobile-blank.svg": 18409,
	"./templates/template-mobile-group.svg": 47370,
	"./templates/template-mobile.svg": 87568,
	"./templates/template-preview.svg": 96718,
	"./theme-dark.svg": 68587,
	"./theme-light.svg": 3937,
	"./theme-system.svg": 25016,
	"./tools/design-guard-thumb.png": 31462,
	"./tools/smart-quotes-thumb.png": 14747,
	"./tools/token-starter-thumb.png": 69489,
	"./work/1-j-logo/config": 75077,
	"./work/1-j-logo/config.json": 75077,
	"./work/1-j-logo/j.svg": 96992,
	"./work/1-j-logo/sketches/j-logo.svg": 15859,
	"./work/1-j-logo/sketches/j-uni.svg": 63204,
	"./work/1-j-logo/sketches/logo.png": 77154,
	"./work/10-stackaudit/config": 93460,
	"./work/10-stackaudit/config.json": 93460,
	"./work/10-stackaudit/sketches/stackaudit-01.png": 22019,
	"./work/10-stackaudit/sketches/stackaudit-02.png": 85160,
	"./work/10-stackaudit/sketches/stackaudit-03.png": 79025,
	"./work/10-stackaudit/sketches/stackaudit-04.png": 12286,
	"./work/10-stackaudit/sketches/stackaudit-05.png": 64775,
	"./work/10-stackaudit/sketches/stackaudit-06.png": 45772,
	"./work/10-stackaudit/sketches/stackaudit-07.png": 98037,
	"./work/10-stackaudit/sketches/stackaudit-08.png": 10834,
	"./work/10-stackaudit/sketches/stackaudit-09.png": 42011,
	"./work/10-stackaudit/stackaudit-icon.svg": 11968,
	"./work/2-gob/config": 6132,
	"./work/2-gob/config.json": 6132,
	"./work/2-gob/gob.svg": 55001,
	"./work/2-gob/sketches/gob-sketches.jpg": 91835,
	"./work/2-gob/sketches/gob-sketches2.jpg": 13137,
	"./work/2-gob/sketches/gob-sketches3.jpg": 34612,
	"./work/2-gob/sketches/gob-sketches4.jpg": 36575,
	"./work/3-avatar/01-sketches/avatar-standing/v01.png": 11342,
	"./work/3-avatar/01-sketches/avatar-standing/v02.png": 81701,
	"./work/3-avatar/01-sketches/avatar-standing1/v01.png": 51113,
	"./work/3-avatar/01-sketches/avatar-standing1/v02.png": 60402,
	"./work/3-avatar/02-original/avatar-a/v01.svg": 96689,
	"./work/3-avatar/02-original/avatar-a/v02.svg": 39586,
	"./work/3-avatar/02-original/avatar-alt.svg": 33103,
	"./work/3-avatar/02-original/avatar-h/v01.svg": 53864,
	"./work/3-avatar/02-original/avatar-h/v02.svg": 35227,
	"./work/3-avatar/02-original/avatar/v01.svg": 23767,
	"./work/3-avatar/02-original/avatar/v02.svg": 19172,
	"./work/3-avatar/03-front-view/front/v01.svg": 53186,
	"./work/3-avatar/03-front-view/front/v02-line.svg": 664,
	"./work/3-avatar/03-front-view/front/v03-line.svg": 38207,
	"./work/3-avatar/03-front-view/front/v04-line.svg": 86142,
	"./work/3-avatar/03-front-view/shirt/v01.svg": 65643,
	"./work/3-avatar/03-front-view/shirt/v02.svg": 7576,
	"./work/3-avatar/04-headshot-outline/avatar-style.svg": 5285,
	"./work/3-avatar/04-headshot-outline/outline/v01.svg": 65046,
	"./work/3-avatar/04-headshot-outline/outline/v02.svg": 6293,
	"./work/3-avatar/04-headshot-outline/outline/v03.svg": 80660,
	"./work/3-avatar/04-headshot-outline/outline/v04.svg": 13723,
	"./work/3-avatar/04-headshot-outline/outline/v05.svg": 95882,
	"./work/3-avatar/04-headshot-outline/outline/v06.svg": 40281,
	"./work/3-avatar/04-headshot-outline/outline/v07.svg": 32360,
	"./work/3-avatar/04-headshot-outline/outline/v08.svg": 25135,
	"./work/3-avatar/05-side-body/bust/v01-line.svg": 50173,
	"./work/3-avatar/05-side-body/bust/v01.svg": 8510,
	"./work/3-avatar/05-side-body/crop-sketch-face/v01-line.svg": 50078,
	"./work/3-avatar/05-side-body/crop-sketch-face/v01.svg": 7711,
	"./work/3-avatar/05-side-body/crop/v01-line.svg": 10937,
	"./work/3-avatar/05-side-body/crop/v01.svg": 36690,
	"./work/3-avatar/05-side-body/crop/v02-line.svg": 67048,
	"./work/3-avatar/05-side-body/crop/v02.svg": 2081,
	"./work/3-avatar/05-side-body/crop/v03-line.svg": 15695,
	"./work/3-avatar/05-side-body/crop/v03.svg": 3632,
	"./work/3-avatar/05-side-body/crop/v04-line.svg": 558,
	"./work/3-avatar/05-side-body/crop/v04.svg": 21103,
	"./work/3-avatar/05-side-body/crop/v05-line.svg": 73021,
	"./work/3-avatar/05-side-body/crop/v05.svg": 58526,
	"./work/3-avatar/05-side-body/crop/v06-line.svg": 5612,
	"./work/3-avatar/05-side-body/crop/v06.svg": 70621,
	"./work/3-avatar/05-side-body/crop/v07-line.svg": 82659,
	"./work/3-avatar/05-side-body/crop/v07.svg": 42076,
	"./work/3-avatar/05-side-body/crop/v08-line.svg": 31877,
	"./work/3-avatar/05-side-body/crop/v08.svg": 44315,
	"./work/3-avatar/05-side-body/crop/v09-line.svg": 71425,
	"./work/3-avatar/05-side-body/crop/v09.svg": 2346,
	"./work/3-avatar/05-side-body/crop/v10-line.svg": 34463,
	"./work/3-avatar/05-side-body/crop/v11-line.svg": 94360,
	"./work/3-avatar/05-side-body/crop/v11.svg": 86897,
	"./work/3-avatar/05-side-body/crop/v12-line.svg": 55017,
	"./work/3-avatar/05-side-body/crop/v12.svg": 66530,
	"./work/3-avatar/05-side-body/crop/v13-line.svg": 15098,
	"./work/3-avatar/05-side-body/crop/v13.svg": 71699,
	"./work/3-avatar/05-side-body/crop/v14-line.svg": 76179,
	"./work/3-avatar/05-side-body/crop/v14.svg": 37804,
	"./work/3-avatar/05-side-body/crop/v15.svg": 36749,
	"./work/3-avatar/05-side-body/crop/v16.svg": 88398,
	"./work/3-avatar/05-side-body/crop/v17-line.svg": 7134,
	"./work/3-avatar/05-side-body/crop/v17.svg": 16831,
	"./work/3-avatar/05-side-body/crop/v18-line.svg": 36967,
	"./work/3-avatar/05-side-body/crop/v18.svg": 13944,
	"./work/3-avatar/05-side-body/crop/v19-line.svg": 4064,
	"./work/3-avatar/05-side-body/crop/v19.svg": 18185,
	"./work/3-avatar/05-side-body/crop/v20-line.svg": 72528,
	"./work/3-avatar/05-side-body/full-sketch-face/v01-line.svg": 6777,
	"./work/3-avatar/05-side-body/full-sketch-face/v01.svg": 24754,
	"./work/3-avatar/05-side-body/full/v01-line.svg": 61846,
	"./work/3-avatar/05-side-body/full/v01.svg": 80999,
	"./work/3-avatar/05-side-body/full/v02-line.svg": 82539,
	"./work/3-avatar/05-side-body/full/v02.svg": 16436,
	"./work/3-avatar/05-side-body/full/v03-line.svg": 32340,
	"./work/3-avatar/05-side-body/full/v03.svg": 89045,
	"./work/3-avatar/05-side-body/full/v04-line.svg": 39777,
	"./work/3-avatar/05-side-body/full/v04.svg": 82186,
	"./work/3-avatar/05-side-body/full/v05-line.svg": 68530,
	"./work/3-avatar/05-side-body/full/v05.svg": 42555,
	"./work/3-avatar/05-side-body/full/v06-line.svg": 23287,
	"./work/3-avatar/05-side-body/full/v06.svg": 91816,
	"./work/3-avatar/05-side-body/full/v07-line.svg": 81584,
	"./work/3-avatar/05-side-body/full/v07.svg": 73561,
	"./work/3-avatar/05-side-body/full/v08-line.svg": 60253,
	"./work/3-avatar/05-side-body/full/v08.svg": 14686,
	"./work/3-avatar/05-side-body/full/v09-line.svg": 26062,
	"./work/3-avatar/05-side-body/full/v09.svg": 58415,
	"./work/3-avatar/05-side-body/full/v10-line.svg": 45160,
	"./work/3-avatar/05-side-body/full/v11-line.svg": 93807,
	"./work/3-avatar/05-side-body/full/v11.svg": 86832,
	"./work/3-avatar/05-side-body/full/v12-line.svg": 28586,
	"./work/3-avatar/05-side-body/full/v12.svg": 69283,
	"./work/3-avatar/05-side-body/full/v13-line.svg": 89049,
	"./work/3-avatar/05-side-body/full/v13.svg": 19890,
	"./work/3-avatar/05-side-body/full/v14-line.svg": 83724,
	"./work/3-avatar/05-side-body/full/v14.svg": 53821,
	"./work/3-avatar/05-side-body/full/v15.svg": 25276,
	"./work/3-avatar/05-side-body/full/v16.svg": 4303,
	"./work/3-avatar/05-side-body/full/v17-line.svg": 67485,
	"./work/3-avatar/05-side-body/full/v17.svg": 41726,
	"./work/3-avatar/05-side-body/full/v18-line.svg": 76272,
	"./work/3-avatar/05-side-body/full/v18.svg": 11545,
	"./work/3-avatar/05-side-body/full/v19-line.svg": 93303,
	"./work/3-avatar/05-side-body/full/v19.svg": 46152,
	"./work/3-avatar/05-side-body/full/v20-line.svg": 58135,
	"./work/3-avatar/05-side-body/head/v01-line.svg": 19393,
	"./work/3-avatar/05-side-body/head/v01.svg": 3978,
	"./work/3-avatar/05-side-body/head/v02-line.svg": 29776,
	"./work/3-avatar/05-side-body/head/v02.svg": 29977,
	"./work/3-avatar/05-side-body/head/v03-line.svg": 46807,
	"./work/3-avatar/05-side-body/head/v03.svg": 64584,
	"./work/3-avatar/05-side-body/head/v04-line.svg": 63318,
	"./work/3-avatar/05-side-body/head/v04.svg": 2183,
	"./work/3-avatar/05-side-body/head/v05-line.svg": 97701,
	"./work/3-avatar/05-side-body/head/v05.svg": 62646,
	"./work/3-avatar/05-side-body/head/v06-line.svg": 96276,
	"./work/3-avatar/05-side-body/head/v07-line.svg": 73707,
	"./work/3-avatar/05-side-body/head/v07.svg": 14324,
	"./work/3-avatar/05-side-body/head/v08-line.svg": 98442,
	"./work/3-avatar/05-side-body/head/v08.svg": 87715,
	"./work/3-avatar/05-side-body/torso-sketch-face/v01-line.svg": 42815,
	"./work/3-avatar/05-side-body/torso-sketch-face/v01.svg": 98816,
	"./work/3-avatar/05-side-body/torso/v01-line.svg": 40904,
	"./work/3-avatar/05-side-body/torso/v01.svg": 36673,
	"./work/3-avatar/05-side-body/torso/v02-line.svg": 54041,
	"./work/3-avatar/05-side-body/torso/v02.svg": 31634,
	"./work/3-avatar/05-side-body/torso/v03-line.svg": 11594,
	"./work/3-avatar/05-side-body/torso/v03.svg": 69571,
	"./work/3-avatar/05-side-body/torso/v04-line.svg": 29283,
	"./work/3-avatar/05-side-body/torso/v04.svg": 11292,
	"./work/3-avatar/05-side-body/torso/v05-line.svg": 46860,
	"./work/3-avatar/05-side-body/torso/v05.svg": 65565,
	"./work/3-avatar/05-side-body/torso/v06-line.svg": 44765,
	"./work/3-avatar/05-side-body/torso/v06.svg": 27742,
	"./work/3-avatar/05-side-body/torso/v07-line.svg": 33454,
	"./work/3-avatar/05-side-body/torso/v07.svg": 90319,
	"./work/3-avatar/05-side-body/torso/v08-line.svg": 67351,
	"./work/3-avatar/05-side-body/torso/v08.svg": 81192,
	"./work/3-avatar/05-side-body/torso/v09-line.svg": 5968,
	"./work/3-avatar/05-side-body/torso/v09.svg": 89113,
	"./work/3-avatar/05-side-body/torso/v10-line.svg": 22170,
	"./work/3-avatar/05-side-body/torso/v11-line.svg": 20969,
	"./work/3-avatar/05-side-body/torso/v11.svg": 29218,
	"./work/3-avatar/05-side-body/torso/v12-line.svg": 30104,
	"./work/3-avatar/05-side-body/torso/v12.svg": 83761,
	"./work/3-avatar/05-side-body/torso/v13-line.svg": 48255,
	"./work/3-avatar/05-side-body/torso/v13.svg": 20960,
	"./work/3-avatar/05-side-body/torso/v14-line.svg": 90078,
	"./work/3-avatar/05-side-body/torso/v14.svg": 79519,
	"./work/3-avatar/05-side-body/torso/v15.svg": 58414,
	"./work/3-avatar/05-side-body/torso/v16.svg": 87533,
	"./work/3-avatar/05-side-body/torso/v17-line.svg": 78035,
	"./work/3-avatar/05-side-body/torso/v17.svg": 7820,
	"./work/3-avatar/05-side-body/torso/v18-line.svg": 610,
	"./work/3-avatar/05-side-body/torso/v18.svg": 15467,
	"./work/3-avatar/05-side-body/torso/v19-line.svg": 49937,
	"./work/3-avatar/05-side-body/torso/v19.svg": 12762,
	"./work/3-avatar/05-side-body/torso/v20-line.svg": 18077,
	"./work/3-avatar/06-front-body/crop/v01-line.svg": 6522,
	"./work/3-avatar/06-front-body/crop/v01.svg": 88467,
	"./work/3-avatar/06-front-body/crop/v02-line.svg": 42239,
	"./work/3-avatar/06-front-body/crop/v03-line.svg": 85784,
	"./work/3-avatar/06-front-body/crop/v03.svg": 26046,
	"./work/3-avatar/06-front-body/crop/v04-line.svg": 78445,
	"./work/3-avatar/06-front-body/crop/v04.svg": 5166,
	"./work/3-avatar/06-front-body/crop/v05-line.svg": 14910,
	"./work/3-avatar/06-front-body/crop/v05.svg": 33599,
	"./work/3-avatar/06-front-body/crop/v06-line.svg": 67603,
	"./work/3-avatar/06-front-body/crop/v06.svg": 54572,
	"./work/3-avatar/06-front-body/crop/v07-line.svg": 59292,
	"./work/3-avatar/06-front-body/crop/v07.svg": 53517,
	"./work/3-avatar/06-front-body/crop/v08.svg": 50490,
	"./work/3-avatar/06-front-body/crop/v09.svg": 81451,
	"./work/3-avatar/06-front-body/crop/v10-line.svg": 97036,
	"./work/3-avatar/06-front-body/crop/v10.svg": 87389,
	"./work/3-avatar/06-front-body/crop/v11-line.svg": 90435,
	"./work/3-avatar/06-front-body/crop/v11.svg": 58844,
	"./work/3-avatar/06-front-body/crop/v12-line.svg": 91982,
	"./work/3-avatar/06-front-body/crop/v12.svg": 37871,
	"./work/3-avatar/06-front-body/crop/v13-line.svg": 80797,
	"./work/3-avatar/06-front-body/crop/v13.svg": 75294,
	"./work/3-avatar/06-front-body/crop/v14-line.svg": 58472,
	"./work/3-avatar/06-front-body/full/v01-line.svg": 7049,
	"./work/3-avatar/06-front-body/full/v01.svg": 49410,
	"./work/3-avatar/06-front-body/full/v02-line.svg": 15416,
	"./work/3-avatar/06-front-body/full/v03-line.svg": 69311,
	"./work/3-avatar/06-front-body/full/v03.svg": 92128,
	"./work/3-avatar/06-front-body/full/v04-line.svg": 894,
	"./work/3-avatar/06-front-body/full/v04.svg": 93247,
	"./work/3-avatar/06-front-body/full/v05-line.svg": 19341,
	"./work/3-avatar/06-front-body/full/v05.svg": 78606,
	"./work/3-avatar/06-front-body/full/v06-line.svg": 14652,
	"./work/3-avatar/06-front-body/full/v06.svg": 61581,
	"./work/3-avatar/06-front-body/full/v07-line.svg": 86195,
	"./work/3-avatar/06-front-body/full/v07.svg": 30572,
	"./work/3-avatar/06-front-body/full/v08.svg": 41099,
	"./work/3-avatar/06-front-body/full/v09.svg": 63578,
	"./work/3-avatar/06-front-body/full/v10-line.svg": 44559,
	"./work/3-avatar/06-front-body/full/v10.svg": 51952,
	"./work/3-avatar/06-front-body/full/v11-line.svg": 36040,
	"./work/3-avatar/06-front-body/full/v11.svg": 43073,
	"./work/3-avatar/06-front-body/full/v12-line.svg": 53625,
	"./work/3-avatar/06-front-body/full/v12.svg": 54386,
	"./work/3-avatar/06-front-body/full/v13-line.svg": 2986,
	"./work/3-avatar/06-front-body/full/v13.svg": 41347,
	"./work/3-avatar/06-front-body/full/v14-line.svg": 23683,
	"./work/3-avatar/06-front-body/head/v01-line.svg": 40614,
	"./work/3-avatar/06-front-body/head/v01.svg": 85591,
	"./work/3-avatar/06-front-body/head/v02-line.svg": 81115,
	"./work/3-avatar/06-front-body/head/v03-line.svg": 31748,
	"./work/3-avatar/06-front-body/head/v03.svg": 97189,
	"./work/3-avatar/06-front-body/head/v04-line.svg": 99889,
	"./work/3-avatar/06-front-body/head/v04.svg": 1914,
	"./work/3-avatar/06-front-body/torso/v01-line.svg": 25537,
	"./work/3-avatar/06-front-body/torso/v01.svg": 43978,
	"./work/3-avatar/06-front-body/torso/v02-line.svg": 50992,
	"./work/3-avatar/06-front-body/torso/v03-line.svg": 9047,
	"./work/3-avatar/06-front-body/torso/v03.svg": 53608,
	"./work/3-avatar/06-front-body/torso/v04-line.svg": 47606,
	"./work/3-avatar/06-front-body/torso/v04.svg": 42791,
	"./work/3-avatar/06-front-body/torso/v05-line.svg": 20965,
	"./work/3-avatar/06-front-body/torso/v05.svg": 78966,
	"./work/3-avatar/06-front-body/torso/v06-line.svg": 1748,
	"./work/3-avatar/06-front-body/torso/v06.svg": 50837,
	"./work/3-avatar/06-front-body/torso/v07-line.svg": 68299,
	"./work/3-avatar/06-front-body/torso/v07.svg": 94580,
	"./work/3-avatar/06-front-body/torso/v08.svg": 11363,
	"./work/3-avatar/06-front-body/torso/v09.svg": 96722,
	"./work/3-avatar/06-front-body/torso/v10-line.svg": 30087,
	"./work/3-avatar/06-front-body/torso/v10.svg": 57080,
	"./work/3-avatar/06-front-body/torso/v11-line.svg": 66656,
	"./work/3-avatar/06-front-body/torso/v11.svg": 82441,
	"./work/3-avatar/06-front-body/torso/v12-line.svg": 39697,
	"./work/3-avatar/06-front-body/torso/v12.svg": 21274,
	"./work/3-avatar/06-front-body/torso/v13-line.svg": 89634,
	"./work/3-avatar/06-front-body/torso/v13.svg": 15147,
	"./work/3-avatar/06-front-body/torso/v14-line.svg": 64123,
	"./work/3-avatar/07-flipped/crop/v01-line.svg": 39345,
	"./work/3-avatar/07-flipped/crop/v01.svg": 3578,
	"./work/3-avatar/07-flipped/crop/v02.svg": 18665,
	"./work/3-avatar/07-flipped/crop/v03.svg": 83800,
	"./work/3-avatar/07-flipped/crop/v04-line.svg": 80070,
	"./work/3-avatar/07-flipped/crop/v04.svg": 3607,
	"./work/3-avatar/07-flipped/crop/v05-line.svg": 32181,
	"./work/3-avatar/07-flipped/crop/v05.svg": 16070,
	"./work/3-avatar/07-flipped/crop/v06-line.svg": 71204,
	"./work/3-avatar/07-flipped/crop/v06.svg": 15205,
	"./work/3-avatar/07-flipped/crop/v07-line.svg": 36923,
	"./work/3-avatar/07-flipped/full/v01-line.svg": 606,
	"./work/3-avatar/07-flipped/full/v01.svg": 82655,
	"./work/3-avatar/07-flipped/full/v02.svg": 3628,
	"./work/3-avatar/07-flipped/full/v03.svg": 2573,
	"./work/3-avatar/07-flipped/full/v04-line.svg": 48489,
	"./work/3-avatar/07-flipped/full/v04.svg": 32354,
	"./work/3-avatar/07-flipped/full/v05-line.svg": 92218,
	"./work/3-avatar/07-flipped/full/v05.svg": 37523,
	"./work/3-avatar/07-flipped/full/v06-line.svg": 27935,
	"./work/3-avatar/07-flipped/full/v06.svg": 16768,
	"./work/3-avatar/07-flipped/full/v07-line.svg": 87832,
	"./work/3-avatar/07-flipped/head/v01-line.svg": 17945,
	"./work/3-avatar/07-flipped/head/v01.svg": 29266,
	"./work/3-avatar/07-flipped/torso/v01-line.svg": 59552,
	"./work/3-avatar/07-flipped/torso/v01.svg": 46761,
	"./work/3-avatar/07-flipped/torso/v02.svg": 21178,
	"./work/3-avatar/07-flipped/torso/v03.svg": 26443,
	"./work/3-avatar/07-flipped/torso/v04-line.svg": 73851,
	"./work/3-avatar/07-flipped/torso/v04.svg": 61732,
	"./work/3-avatar/07-flipped/torso/v05-line.svg": 55812,
	"./work/3-avatar/07-flipped/torso/v05.svg": 39749,
	"./work/3-avatar/07-flipped/torso/v06-line.svg": 64277,
	"./work/3-avatar/07-flipped/torso/v06.svg": 19878,
	"./work/3-avatar/07-flipped/torso/v07-line.svg": 16614,
	"./work/3-avatar/08-illustrator/2026-headshot-flipped-nobg.svg": 62169,
	"./work/3-avatar/08-illustrator/2026-headshot-flipped.svg": 70812,
	"./work/3-avatar/08-illustrator/2026-headshot-nobg.svg": 96868,
	"./work/3-avatar/08-illustrator/2026-headshot.svg": 48739,
	"./work/3-avatar/08-illustrator/2026-torso-clean/v01.svg": 68360,
	"./work/3-avatar/08-illustrator/2026-torso-clean/v02.svg": 83899,
	"./work/3-avatar/08-illustrator/2026-torso-nobg/v01.svg": 51325,
	"./work/3-avatar/08-illustrator/2026-torso-nobg/v02.svg": 39230,
	"./work/3-avatar/08-illustrator/2026-torso/v01-line.svg": 17531,
	"./work/3-avatar/08-illustrator/2026-torso/v01.svg": 50276,
	"./work/3-avatar/08-illustrator/torso-flipped.svg": 62400,
	"./work/3-avatar/08-illustrator/torso.svg": 99247,
	"./work/3-avatar/09-chat-button/face/v01.svg": 28396,
	"./work/3-avatar/09-chat-button/face/v02.svg": 91071,
	"./work/3-avatar/09-chat-button/face/v03.svg": 53134,
	"./work/3-avatar/09-chat-button/face/v04.svg": 34961,
	"./work/3-avatar/09-chat-button/face/v05.svg": 78048,
	"./work/3-avatar/09-chat-button/face/v06.svg": 68787,
	"./work/3-avatar/09-chat-button/face/v07.svg": 54562,
	"./work/3-avatar/09-chat-button/face/v08.svg": 73029,
	"./work/3-avatar/09-chat-button/face/v09.svg": 95012,
	"./work/3-avatar/09-chat-button/face/v10.svg": 82834,
	"./work/3-avatar/10-footer-mockups/footer-avatar-body-crop-desktop.png": 22142,
	"./work/3-avatar/10-footer-mockups/footer-avatar-body-crop-flipped-desktop.png": 28825,
	"./work/3-avatar/10-footer-mockups/footer-avatar-body-crop-flipped-mobile.png": 42563,
	"./work/3-avatar/10-footer-mockups/footer-avatar-body-crop-mobile.png": 66354,
	"./work/3-avatar/10-footer-mockups/footer-avatar-torso-desktop.png": 48160,
	"./work/3-avatar/10-footer-mockups/footer-avatar-torso-mobile.png": 63260,
	"./work/3-avatar/10-footer-mockups/footer-figure-desktop-wink.png": 34185,
	"./work/3-avatar/10-footer-mockups/footer-figure-desktop.png": 29885,
	"./work/3-avatar/10-footer-mockups/footer-figure-mobile.png": 74479,
	"./work/3-avatar/10-footer-mockups/footer-layout-A-desktop.png": 20369,
	"./work/3-avatar/10-footer-mockups/footer-layout-A-mobile.png": 63883,
	"./work/3-avatar/10-footer-mockups/footer-layout-B-desktop.png": 78986,
	"./work/3-avatar/10-footer-mockups/footer-layout-B-mobile.png": 54,
	"./work/3-avatar/10-footer-mockups/footer-layout-C-desktop.png": 94491,
	"./work/3-avatar/10-footer-mockups/footer-layout-C-mobile.png": 37229,
	"./work/3-avatar/10-footer-mockups/footer-redesign-desktop-dark.png": 26491,
	"./work/3-avatar/10-footer-mockups/footer-redesign-desktop-wink.png": 84290,
	"./work/3-avatar/10-footer-mockups/footer-redesign-desktop.png": 48200,
	"./work/3-avatar/10-footer-mockups/footer-redesign-mobile.png": 39796,
	"./work/3-avatar/10-footer-mockups/footer-redesign-tablet.png": 94058,
	"./work/3-avatar/10-footer-mockups/placement-nav-desktop.png": 92214,
	"./work/3-avatar/10-footer-mockups/placement-nav-mobile.png": 59482,
	"./work/3-avatar/10-footer-mockups/placement-portrait-desktop.png": 5822,
	"./work/3-avatar/10-footer-mockups/placement-portrait-mobile.png": 26322,
	"./work/3-avatar/10-footer-mockups/placement-standing-desktop.png": 27079,
	"./work/3-avatar/10-footer-mockups/placement-standing-mobile.png": 13713,
	"./work/3-avatar/INDEX.md": 59348,
	"./work/3-avatar/README.md": 70941,
	"./work/3-avatar/avatar.svg": 51676,
	"./work/3-avatar/config": 4226,
	"./work/3-avatar/config.json": 4226,
	"./work/4-dod/config": 54147,
	"./work/4-dod/config.json": 54147,
	"./work/4-dod/dod.svg": 26263,
	"./work/4-dod/sketches/dod-program.png": 66851,
	"./work/4-mailback/config": 40860,
	"./work/4-mailback/config.json": 40860,
	"./work/4-mailback/mailback.svg": 23049,
	"./work/5-findmy/config": 55720,
	"./work/5-findmy/config.json": 55720,
	"./work/5-findmy/find-me.svg": 33695,
	"./work/6-a-logo/a-logo.svg": 22245,
	"./work/6-a-logo/config": 66913,
	"./work/6-a-logo/config.json": 66913,
	"./work/8-r-face/config": 63868,
	"./work/8-r-face/config.json": 63868,
	"./work/8-r-face/r-face.svg": 52401,
	"./work/8-r-face/sketches/jr-scratchpad-2021-01.svg": 21780,
	"./work/8-r-face/sketches/jr-scratchpad-2021-02.svg": 69991,
	"./work/9-r-logo/config": 51509,
	"./work/9-r-logo/config.json": 51509,
	"./work/9-r-logo/r-eye.svg": 46384,
	"./work/99-scope/config": 61268,
	"./work/99-scope/config.json": 61268,
	"./work/99-scope/scope.svg": 3395,
	"./work/999-send-mail/config": 95827,
	"./work/999-send-mail/config.json": 95827,
	"./work/999-send-mail/send-mail.svg": 30376,
	"./work/_template/config": 58860,
	"./work/_template/config.json": 58860,
	"./work/fyposter.png": 23425,
	"./work/genesis-logo-v-blue.svg": 30329,
	"./work/genesis-logo-v-white.svg": 54104,
	"./work/gob.svg": 68861,
	"./work/placeholder.png": 27466,
	"./work/wireframe-lib.png": 44265
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 73811;